import { useMemo } from 'react';

import { useGetOptionsForCLA } from 'hooks/useGetOptionsForCLA';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

import { singleSelectValueFormatter } from 'components/shared/DataGrid/utils/valueFormatters/singleSelectValueFormatter';

import { GridColDef } from '@mui/x-data-grid-pro';
import { Option } from 'components/shared/ControlledFields/ControlledSelect';
import { dateFormatter, nestedFieldValueGetter } from 'utils/grid';

const useColumnDefinitions = () => {
  const { t } = useTranslation();
  const typeOptions = [
    t('max_buh.grid.claType.max_buh'),
    t('max_buh.grid.claType.max_sleeping_allowance')
  ];
  const claOptions = useGetOptionsForCLA();

  return useMemo(() => {
    return generateColumns(t, typeOptions, claOptions);
  }, [t, claOptions, typeOptions]);
};

const generateColumns = (
  t: TFunction,
  typeOptions: string[],
  claOptions: Option[]
): GridColDef[] => [
  {
    field: 'claId',
    headerName: t('max_buh.grid.claId'),
    type: 'singleSelect',
    hideable: false,
    flex: 1,
    minWidth: 70,
    valueOptions: claOptions,
    valueFormatter: (value: string | number) => singleSelectValueFormatter(value, claOptions)
  },
  {
    field: 'type',
    headerName: t('max_buh.grid.type'),
    type: 'singleSelect',
    flex: 1,
    minWidth: 170,
    valueOptions: typeOptions
  },
  {
    field: 'value',
    headerName: t('max_buh.grid.buhSalaryMax'),
    type: 'number',
    flex: 1,
    minWidth: 70,
    align: 'left',
    headerAlign: 'left'
  },
  {
    field: 'valid.from',
    headerName: t('validFrom'),
    type: 'date',
    valueGetter: (_, row) => nestedFieldValueGetter('valid.from', row),
    valueFormatter: dateFormatter,
    width: 110
  },
  {
    field: 'valid.to',
    headerName: t('validTo'),
    type: 'date',
    valueGetter: (_, row) => nestedFieldValueGetter('valid.to', row),
    valueFormatter: dateFormatter,
    width: 110
  }
];

export default useColumnDefinitions;
